import React from "react";
import {
  Table,
  Space,
  Button,
  Tooltip,
  Dropdown,
  Menu,
  Tag,
  Typography,
  Spin,
} from "antd";
import {
  FaEye,
  FaTags,
  FaEnvelope,
  FaEllipsisV,
  FaUserAlt,
} from "react-icons/fa";
import moment from "moment";

const { Text } = Typography;

const CustomerTable = ({
  customers,
  statusOptions,
  tagOptions,
  onViewCustomer,
  onManageTags,
  onSendEmail,
  onStatusChange,
  loaders
}) => {
  const columns = [
    {
      title: "Customer",
      key: "name",
      fixed: 'left', // Fixed column on scroll
      width: 250, // Set a fixed width
      render: (record) => (
        <Space>
          <div className="flex items-center">
            <div className="bg-blue-100 text-blue-700 rounded-full w-10 h-10 flex items-center justify-center mr-3">
              <FaUserAlt />
            </div>
            <div>
              <div className="font-medium whitespace-nowrap">{`${record?.first_name} ${record?.last_name}`}</div>
              <div className="text-gray-500 text-xs truncate" style={{ maxWidth: '150px' }}>{record?.email}</div>
            </div>
          </div>
        </Space>
      ),
      sorter: (a, b) =>
        `${a.first_name} ${a.last_name}`.localeCompare(
          `${b.first_name} ${b.last_name}`
        ),
    },
    {
      title: "Phone",
      key: "phone",
      // width: 150,
      render: (record) => {
        const phone =
          record.shipping_address?.[0]?.phone ||
          record.orders?.[0]?.customer_info?.phone ||
          "N/A";
        return <Text className="whitespace-nowrap">{phone}</Text>;
      },
    },
    {
      title: "Orders",
      key: "totalOrders",
      // width: 100,
      render: (record) => record.orders?.length || 0,
      sorter: (a, b) => (a.orders?.length || 0) - (b.orders?.length || 0),
    },
    {
      title: "Created On",
      key: "createdAt",
      // width: 150,
      render: (record) => moment(record.createdAt).format("MMM DD, YYYY"),
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
    },
    {
      title: "Tags",
      key: "tags",
      // width: 200,
      render: (record) => (
        <div className="flex flex-wrap gap-1">
          {record.tags && record.tags.length > 0 ? (
            record.tags.map((tag) => {
              const tagOption = tagOptions.find((t) => t.value === tag);
              return (
                <Tag color={tagOption?.color || "blue"} key={tag}>
                  {tag}
                </Tag>
              );
            })
          ) : (
            <Text type="secondary">No tags</Text>
          )}
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (status) => {
        const statusOption = statusOptions.find((s) => s.value === status);
        return <Tag color={statusOption?.color || "default"}>{status}</Tag>;
      },
      filters: statusOptions.map((option) => ({
        text: option.label,
        value: option.value,
      })),
      onFilter: (value, record) => record.status === value,
    },
    {
      title: "Actions",
      key: "actions",
      // fixed: 'right', // Fixed column on scroll
      width: 150,
      render: (record) => (
        <Space>
          <Tooltip title="View Details">
            <Button 
              onClick={() => onViewCustomer(record)} 
              icon={<FaEye />} 
              size="small"
            />
          </Tooltip>
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item
                  key="1"
                  icon={<FaTags />}
                  onClick={() => onManageTags(record)}
                >
                  Manage Tags
                </Menu.Item>
                <Menu.Item
                  key="2"
                  icon={<FaEnvelope />}
                  onClick={() => onSendEmail(record)}
                >
                  Send Email
                </Menu.Item>
                <Menu.Divider />
                {record.status === "Active" ? (
                  <Menu.Item
                    key="3"
                    danger
                    onClick={() => onStatusChange(record, "In-Active")}
                  >
                    Deactivate Account
                  </Menu.Item>
                ) : (
                  <Menu.Item
                    key="3"
                    onClick={() => onStatusChange(record, "Active")}
                  >
                    Activate Account
                  </Menu.Item>
                )}
              </Menu>
            }
          >
            <Button icon={<FaEllipsisV />} size="small" />
          </Dropdown>
        </Space>
      ),
    },
  ];

  return (
    <div className="responsive-table-container">
      {loaders ? (
        <div className="flex items-center justify-center h-[40vh]">
          <Spin size="large" className="flex justify-center" />
        </div>
      ) : (
        <Table
          columns={columns}
          dataSource={customers}
          pagination={{ pageSize: 10 }}
          rowKey="_id"
          scroll={{ x: 1000 }} // Enable horizontal scrolling
          className="custom-responsive-table"
          size="middle"
        />
      )}
    </div>
  );
};

export default CustomerTable;